import DownloadIcon from '@mui/icons-material/CloudDownloadOutlined'
import { styled, Tooltip, IconButton } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import { useParams } from 'react-router-dom'
import { activeAlbumIdVar } from '../../../../../providers/apollo/cache'
import useBucketDownload from '../../../hooks/useBucketDownload'
import useSelectedAlbums from '../../../hooks/useSelectedAlbums'

const PillButton = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  color: '#fff',
  fontWeight: 500,
  fontSize: '0.875rem',
  cursor: 'pointer',
  gap: 8
})

export default function AlbumDownloadPillButton() {
  const { bucketId, albumId } = useParams<{ bucketId: string; albumId: string }>()
  const { selectedAlbums } = useSelectedAlbums()
  const { downloadAlbums, downloadMultipleMediaResults } = useBucketDownload()
  const { loading } = downloadMultipleMediaResults
  const containsRootAlbum = Array.from(selectedAlbums.keys()).includes(bucketId as string)
  const disabled = !bucketId || containsRootAlbum || (selectedAlbums.size < 1 && !albumId)

  const onClick = () => {
    if (disabled) {
      return
    }

    const selectedAlbumIds = Array.from(selectedAlbums.keys())

    if (albumId) {
      activeAlbumIdVar(albumId)
      downloadAlbums(bucketId, [albumId])
    } else if (selectedAlbumIds.length > 0) {
      downloadAlbums(bucketId, selectedAlbumIds)
    } else {
      downloadAlbums(bucketId)
    }
  }

  if (disabled) {
    return null
  }

  return (
    <Tooltip title="Download Album" arrow>
      <PillButton as="span">
        <IconButton
          disabled={disabled}
          color="primary"
          aria-label="Download Album"
          onClick={onClick}
          id="download-album-pill-button"
          data-test="download-album-pill-button"
          sx={{ color: '#fff' }}
        >
          {loading && <CircularProgress size={20} />}
          {!loading && <DownloadIcon />}
        </IconButton>
        <span style={{ color: disabled ? 'rgba(0, 0, 0, 0.38)' : '#fff' }}>Download</span>
      </PillButton>
    </Tooltip>
  )
}
